Bingo.MultiStepForm = {};

Bingo.MultiStepForm.init = function (currentStep) {
    hideInactive = function (step) {
        $('.multistep-panel').each(function () {
            const key = $(this).data('key');
            const mode = $(this).data('mode');
            if ((key !== step && mode === 'open') || (key === step && mode === 'collapsed')) {
                $(this).hide();
            } else {
                $(this).show();
            }
        });
    };
    switchPanel = function (step) {
        $('.multistep-section').each(function () {
            const key = $(this).data('section-id');
            if ((key !== step)) {
                $(this).removeClass('section-editing-active');
                $(this).find('.multistep-switch').show();
                $(this).find('.multistep-close').hide();
            } else {
                $(this).addClass('section-editing-active');
                $(this).find('.multistep-switch').hide();
                $(this).find('.multistep-close').show();
            }
        });
        Bingo.SectionEditing.updateBody();
    };
    hideInactive(currentStep);
    switchPanel(currentStep);
    $('.multistep-switch').click(function () {
        switchTo = $(this).data('id');
        if (switchTo && switchTo.length > 0) {
            e.preventDefault();
        }
        if (!$(this).attr('data-allow-hiding-inactive')) {
            hideInactive(switchTo);
        }
        switchPanel(switchTo);
        $('#preview-buttons').hide();
    });
    $('#modal-offer-cancel').appendTo('body');
    closePanel = function (el) {
        if ($('#modal-cancel').length) {
            $('#modal-cancel').modal('show');
        } else {
            el.parents('.multistep-section').find('[name=cancel]').click();
        }
        return false;
    };
    $('body').on('click', '.section-heading a.close', function () {
        closePanel($(this));
    });
    $('body').on('keypress', '.section-heading a.close', function (e) {
        if (e.keyCode === 13) {
            closePanel($(this));
        }
    });
    $('.multistep-section input, .multistep-section select, .multistep-section textarea').on('change input', () => {
        $('.multistep-switch').hide();
    });
    $('body').on('click', '.multistep-section .btn, .multistep-section a:not(.multistep-switch):not(.gallery-control):not(.cover):not([data-fancybox]):not([data-toggle="tab"]):not([target="_blank"]), .multistep-section .cke_button_icon', () => {
        $('.multistep-switch').hide();
    });
};

Bingo.MultiStepForm.Offer = {};

Bingo.MultiStepForm.Offer.init = function (currentStep) {
    checkFragment = function (step) {
        const url = $(window.location).attr('href');
        if (url.match(/#step-[0-9]+/) == null) {
            $(window.location).attr('href', `#step-${step}`);
        }
    };
    checkFragment(currentStep);
};

Bingo.MultiStepForm.DeveloperProject = {};

Bingo.MultiStepForm.DeveloperProject.init = function () {
    CKEDITOR.on('instanceReady', () => {
        $('.cke_contents iframe').contents().click(() => {
            $('.multistep-switch').hide();
        });
    });
};
